// i18next-extract-mark-ns-start inspirations
/* eslint-disable max-lines */
/* eslint-disable max-lines-per-function */
import { isMultilingual } from '../../../../languages';

// couture
import interieurCover from '../../../assets/ourServices/couturier/interieur.cover.jpg';
import interieurCoverEn from '../../../assets/ourServices/couturier/interieur.en.cover.jpg';
import accessoiresCover from '../../../assets/ourServices/couturier/accessoires.cover.jpg';
import accessoiresCoverEn from '../../../assets/ourServices/couturier/accessoires.en.cover.jpg';
import dressingCover from '../../../assets/ourServices/couturier/dressing.cover.jpg';
import dressingCoverEn from '../../../assets/ourServices/couturier/dressing.en.cover.jpg';
import sofa from '../../../assets/ourServices/couturier/sofa.inspirations.jpg';
import sofaMobile from '../../../assets/ourServices/couturier/sofa.mobile.inspirations.jpg';
import cushion from '../../../assets/ourServices/couturier/cushion.mobile.inspirations.jpg';
import curtain from '../../../assets/ourServices/couturier/curtain.inspirations.jpg';
import plaid from '../../../assets/ourServices/couturier/plaid.inspirations.jpg';
import tableCloth from '../../../assets/ourServices/couturier/tableCloth.inspirations.jpg';
import besace from '../../../assets/ourServices/couturier/besace.inspirations.jpg';
import besaceMobile from '../../../assets/ourServices/couturier/besace.mobile.inspirations.jpg';
import cabas from '../../../assets/ourServices/couturier/cabas.inspirations.jpg';
import trousse from '../../../assets/ourServices/couturier/trousse.inspirations.jpg';
import pochette from '../../../assets/ourServices/couturier/pochette.inspirations.jpg';
import chemise from '../../../assets/ourServices/couturier/chemise.inspirations.jpg';
import ourlet from '../../../assets/ourServices/couturier/ourlet.inspirations.jpg';
import doublure from '../../../assets/ourServices/couturier/doublure.inspirations.jpg';
import costume from '../../../assets/ourServices/couturier/costume.inspirations.jpg';
import coudière from '../../../assets/ourServices/couturier/coudiere.mobile.inspirations.jpg';

// maroquinerie
import ceintureCover from '../../../assets/ourServices/leatherGoods/ceinture.cover.jpg';
import ceintureCoverEn from '../../../assets/ourServices/leatherGoods/ceinture.en.cover.jpg';
import sacCover from '../../../assets/ourServices/leatherGoods/sac.cover.jpg';
import sacCoverEn from '../../../assets/ourServices/leatherGoods/sac.en.cover.jpg';
import petiteMaroCover from '../../../assets/ourServices/leatherGoods/petiteMaro.cover.jpg';
import petiteMaroCoverEn from '../../../assets/ourServices/leatherGoods/petiteMaro.en.cover.jpg';
import ceinture1 from '../../../assets/ourServices/leatherGoods/ceinture.inspirations.jpg';
import ceinture1Mobile from '../../../assets/ourServices/leatherGoods/ceinture.mobile.inspirations.jpg';
import ceinture2 from '../../../assets/ourServices/leatherGoods/ceinture2.inspirations.jpg';
import ceinture3 from '../../../assets/ourServices/leatherGoods/ceinture3.inspirations.jpg';
import ceinture4 from '../../../assets/ourServices/leatherGoods/ceinture4.inspirations.jpg';
import ceinture5 from '../../../assets/ourServices/leatherGoods/ceinture5.mobile.inspirations.jpg';
import sac1 from '../../../assets/ourServices/leatherGoods/sac.inspirations.jpg';
import sac1Mobile from '../../../assets/ourServices/leatherGoods/sac.mobile.inspirations.jpg';
import sac2 from '../../../assets/ourServices/leatherGoods/sac2.inspirations.jpg';
import sac3 from '../../../assets/ourServices/leatherGoods/sac3.inspirations.jpg';
import sac4 from '../../../assets/ourServices/leatherGoods/sac4.inspirations.jpg';
import sac5 from '../../../assets/ourServices/leatherGoods/sac5.mobile.inspirations.jpg';
import petiteMaro1 from '../../../assets/ourServices/leatherGoods/petiteMaro.mobile.inspirations.jpg';
import petiteMaro2 from '../../../assets/ourServices/leatherGoods/petiteMaro2.inspirations.jpg';
import petiteMaro3 from '../../../assets/ourServices/leatherGoods/petiteMaro3.inspirations.jpg';
import petiteMaro4 from '../../../assets/ourServices/leatherGoods/petiteMaro4.inspirations.jpg';
import petiteMaro5 from '../../../assets/ourServices/leatherGoods/petiteMaro5.mobile.inspirations.jpg';

// broderie
import broderieCover from '../../../assets/ourServices/embroidery/broderie.cover.jpg';
import broderieCoverEn from '../../../assets/ourServices/embroidery/broderie.en.cover.jpg';
import broderie1 from '../../../assets/ourServices/embroidery/broderie.inspirations.jpg';
import broderie2 from '../../../assets/ourServices/embroidery/broderie2.mobile.inspirations.jpg';
import broderie3 from '../../../assets/ourServices/embroidery/broderie3.inspirations.jpg';
import broderie4 from '../../../assets/ourServices/embroidery/broderie4.inspirations.jpg';
import broderie5 from '../../../assets/ourServices/embroidery/broderie5.inspirations.jpg';
import broderie6 from '../../../assets/ourServices/embroidery/broderie6.inspirations.jpg';
import broderie7 from '../../../assets/ourServices/embroidery/broderie7.inspirations.jpg';
import broderie8 from '../../../assets/ourServices/embroidery/broderie8.mobile.inspirations.jpg';
import broderie9 from '../../../assets/ourServices/embroidery/broderie9.inspirations.jpg';
import broderie10 from '../../../assets/ourServices/embroidery/broderie10.inspirations.jpg';
import broderie11 from '../../../assets/ourServices/embroidery/broderie11.mobile.inspirations.jpg';
import broderie12 from '../../../assets/ourServices/embroidery/broderie12.inspirations.jpg';
import broderie13 from '../../../assets/ourServices/embroidery/broderie13.mobile.inspirations.jpg';
import broderie14 from '../../../assets/ourServices/embroidery/broderie14.mobile.inspirations.jpg';
import broderie15 from '../../../assets/ourServices/embroidery/broderie15.mobile.inspirations.jpg';

// shoes
import heelsCover from '../../../assets/ourServices/leatherGoods/heels.cover.jpg';
import heelsCoverEn from '../../../assets/ourServices/leatherGoods/heels.en.cover.jpg';
import heels1 from '../../../assets/ourServices/leatherGoods/heels1.inspirations.jpg';
import heels2 from '../../../assets/ourServices/leatherGoods/heels2.inspirations.jpg';
import heels3 from '../../../assets/ourServices/leatherGoods/heels3.inspirations.jpg';
import heels4 from '../../../assets/ourServices/leatherGoods/heels4.inspirations.jpg';
import bootsCover from '../../../assets/ourServices/leatherGoods/boots.cover.jpg';
import bootsCoverEn from '../../../assets/ourServices/leatherGoods/boots.en.cover.jpg';
import boots1 from '../../../assets/ourServices/leatherGoods/boots1.inspirations.jpg';
import sneakersCover from '../../../assets/ourServices/leatherGoods/sneakers.cover.jpg';
import sneakersCoverEn from '../../../assets/ourServices/leatherGoods/sneakers.en.cover.jpg';
import sneakers1 from '../../../assets/ourServices/leatherGoods/sneakers1.inspirations.jpg';
import sneakers2 from '../../../assets/ourServices/leatherGoods/sneakers2.inspirations.jpg';
import sneakers3 from '../../../assets/ourServices/leatherGoods/sneakers3.inspirations.jpg';
import sneakers4 from '../../../assets/ourServices/leatherGoods/sneakers4.inspirations.jpg';

export const inspirationsImages = {
  dressing: {
    mobileImages: [costume, doublure, ourlet, coudière, chemise],
    largeImages: [isMultilingual ? dressingCoverEn : dressingCover, costume],
    smallImages: [doublure, ourlet, chemise],
  },
  interior: {
    mobileImages: [plaid, tableCloth, curtain, sofaMobile, cushion],
    largeImages: [isMultilingual ? interieurCoverEn : interieurCover, sofa],
    smallImages: [plaid, tableCloth, curtain],
  },
  accessories: {
    mobileImages: [pochette, trousse, cabas, besaceMobile],
    largeImages: [isMultilingual ? accessoiresCoverEn : accessoiresCover, pochette],
    smallImages: [trousse, cabas, besace],
  },
  belt: {
    mobileImages: [ceinture3, ceinture4, ceinture2, ceinture1Mobile, ceinture5],
    largeImages: [isMultilingual ? ceintureCoverEn : ceintureCover, ceinture1],
    smallImages: [ceinture2, ceinture3, ceinture4],
  },
  bag: {
    mobileImages: [sac5, sac2, sac3, sac1Mobile, sac4],
    largeImages: [isMultilingual ? sacCoverEn : sacCover, sac1],
    smallImages: [sac2, sac3, sac4],
  },
  smallLeatherGoods: {
    mobileImages: [petiteMaro4, petiteMaro2, petiteMaro3, petiteMaro1, petiteMaro5],
    largeImages: [isMultilingual ? petiteMaroCoverEn : petiteMaroCover, petiteMaro1],
    smallImages: [petiteMaro2, petiteMaro3, petiteMaro4],
  },
  dressingEmbroidery: {
    mobileImages: [broderie5, broderie7, broderie6, broderie8, broderie15],
    largeImages: [isMultilingual ? broderieCoverEn : broderieCover, broderie5],
    smallImages: [broderie6, broderie7, broderie8],
  },
  interiorEmbroidery: {
    mobileImages: [broderie3, broderie1, broderie4, broderie2, broderie13],
    largeImages: [isMultilingual ? broderieCoverEn : broderieCover, broderie1],
    smallImages: [broderie2, broderie3, broderie4],
  },
  accessoriesEmbroidery: {
    mobileImages: [broderie10, broderie9, broderie14, broderie11, broderie12],
    largeImages: [isMultilingual ? broderieCoverEn : broderieCover, broderie9],
    smallImages: [broderie10, broderie11, broderie12],
  },
  boots: {
    mobileImages: [boots1],
    largeImages: [isMultilingual ? bootsCoverEn : bootsCover, boots1],
    smallImages: [],
  },
  heels: {
    mobileImages: [heels1, heels2, heels3, heels4],
    largeImages: [isMultilingual ? heelsCoverEn : heelsCover, heels1],
    smallImages: [heels2, heels3, heels4],
  },
  sneakers: {
    mobileImages: [sneakers1, sneakers2, sneakers3, sneakers4],
    largeImages: [isMultilingual ? sneakersCoverEn : sneakersCover, sneakers1],
    smallImages: [sneakers2, sneakers3, sneakers4],
  },
};

export const getInspirationsInfos = (isMobile, t) => ({
  dressing: [
    {
      title: t('Cintrage épaules'),
      text: t('Cintrage des épaules d‘une veste de costume homme.'),
      price: t('62€'),
      preFilledSteps: {
        selectedCategory: 'clothes',
        selectedCloth: 'cost',
      },
    },
    {
      title: t('Changement de doublure'),
      text: t(
        'Changement intégral de la doublure d’un manteau avec tissu fleuri fourni par la cliente.',
      ),
      price: t('105€'),
      preFilledSteps: {
        selectedCategory: 'clothes',
        selectedCloth: 'mant',
      },
    },
    {
      title: t('Ourlet maille'),
      text: t('Ourlet main sur robe en laine.'),
      price: t('17€'),
      preFilledSteps: {
        selectedCategory: 'clothes',
        selectedCloth: 'pull',
      },
    },
    ...(isMobile ? [{
      title: t('Pose de coudière'),
      text: t(
        'Renforts sur trous au niveau des coudes + pose de coudières sur un pull en maille.',
      ),
      price: t('45€'),
      preFilledSteps: {
        selectedCategory: 'clothes',
        selectedCloth: 'haut',
      },
    }] : []),
    {
      title: t('Upcycling chemise'),
      text: t(
        'Transformation d’une chemise oversize avec ajout de lin, effilochage et création de 3 boutonnières.',
      ),
      price: t('28€'),
      preFilledSteps: {
        selectedCategory: 'clothes',
        selectedCloth: 'haut',
      },
    },
  ],
  interior: [
    ...(!isMobile ? [{
      title: t('Housse de canapé'),
      text: t(
        'Revêtement d’un canapé 170cm en lin (matière fournie par le client). Assise + housses + dossier. ',
      ),
      price: t('228€'),
      preFilledSteps: {
        selectedCategory: 'deco',
        selectedPiece: 'sofa',
      },
    }] : []),
    {
      title: t('Création de plaid'),
      text: t(
        'Création d‘un dessus de lit / plaid de 2m doublé. Tissu fourni par le client.',
      ),
      price: t('66€'),
      preFilledSteps: {
        selectedCategory: 'deco',
        selectedPiece: 'plaid',
      },
    },
    {
      title: t('Création serviette'),
      text: t('Création d‘un jeu de serviette de table à partir d‘une nappe ancienne.'),
      price: t('12€ la pièce'),
      preFilledSteps: {
        selectedCategory: 'deco',
        selectedPiece: 'napkins',
      },
    },
    {
      title: t('Création rideau'),
      text: t(
        'Création d‘un rideau sur mesure de 140 cm x 200 cm, non doublé, avec pattes apparentes.',
      ),
      price: t('106€ le pan'),
      preFilledSteps: {
        selectedCategory: 'deco',
        selectedPiece: 'ride',
      },
    },
    ...(isMobile ? [{
      title: t('Housse de canapé'),
      text: t(
        'Revêtement d’un canapé 170cm en lin (matière fournie par le client). Assise + housses + dossier.',
      ),
      price: t('228€'),
      preFilledSteps: {
        selectedCategory: 'deco',
        selectedPiece: 'sofa',
      },
    },
    {
      title: t('Grand coussin'),
      text: t(
        'Housse de coussin >45cm avec fermeture à boutons. Tissu et intérieur fourni par le client.',
      ),
      price: t('21€'),
      preFilledSteps: {
        selectedCategory: 'deco',
        selectedPiece: 'cous',
      },
    }] : []),
  ],
  accessories: [
    {
      title: t('Pochette ordinateur'),
      text: t(
        'Création d’une pochette d’ordinateur molletonné avec boutons pressions en fermeture.',
      ),
      price: t('41€'),
      preFilledSteps: {
        selectedCategory: 'accessories',
        selectedAccessory: 'bag',
        selectedFabric: 'textile',
      },
    },
    {
      title: t('Création de trousse'),
      text: t('Création d‘une trousse avec de la gaze de coton.'),
      price: t('23€'),
      preFilledSteps: {
        selectedCategory: 'accessories',
        selectedAccessory: 'bag',
        selectedFabric: 'textile',
      },
    },
    {
      title: t('Cabas de plage'),
      text: t('Création d‘un sac de plage en recyclant un tapis de bain.'),
      price: t('30€'),
      preFilledSteps: {
        selectedCategory: 'accessories',
        selectedAccessory: 'bag',
        selectedFabric: 'textile',
      },
    },
    {
      title: t('Création d‘une besace'),
      text: t('Création d‘un petit sac rond avec anse en chaîne bronze et oeillets.'),
      price: t('103€'),
      preFilledSteps: {
        selectedCategory: 'accessories',
        selectedAccessory: 'bag',
        selectedFabric: 'textile',
      },
    },
  ],
  belt: [
    ...(isMobile ? [] : [
      {
        title: t('Recoloration ceinture'),
        text: t('Recoloration d’une ceinture pour lui redonner un coup d‘éclat.'),
        price: t('60€'),
        preFilledSteps: {
          selectedCategory: 'accessories',
          selectedAccessory: 'belt',
        },
      },
      {
        title: t('Couture ceinture'),
        text: t(
          'Réparation de la couture blanche des pourtours sur une ceinture vintage. ',
        ),
        price: t('20€'),
        preFilledSteps: {
          selectedCategory: 'accessories',
          selectedAccessory: 'belt',
        },
      },
    ]),
    {
      title: t('Imperméabilisation'),
      text: t(
        'Soin pour protéger la ceinture en nubuck à l‘eau et à l‘humidité. À renouveler tous les ans.',
      ),
      price: t('15€'),
      preFilledSteps: {
        selectedCategory: 'accessories',
        selectedAccessory: 'belt',
      },
    },
    {
      title: t('Nettoyage & cirage'),
      text: t('Remise en état de cette ceinture El Charro vintage.'),
      price: t('28€'),
      preFilledSteps: {
        selectedCategory: 'accessories',
        selectedAccessory: 'belt',
      },
    },
    ...(isMobile ? [{
      title: t('Couture ceinture'),
      text: t(
        'Réparation de la couture blanche des pourtours sur une ceinture vintage. ',
      ),
      price: t('20€'),
      preFilledSteps: {
        selectedCategory: 'accessories',
        selectedAccessory: 'belt',
      },
    },
    {
      title: t('Recoloration ceinture'),
      text: t('Recoloration d’une ceinture pour lui redonner un coup d‘éclat.'),
      price: t('60€'),
      preFilledSteps: {
        selectedCategory: 'accessories',
        selectedAccessory: 'belt',
      },
    },
    {
      title: t('Réparation couture'),
      text: t('Couture appoint sur la bande bleu jeans.'),
      price: t('5€'),
      preFilledSteps: {
        selectedCategory: 'accessories',
        selectedAccessory: 'belt',
      },
    }] : []),
  ],
  bag: [
    ...(isMobile ? [{
      title: t('Réparation anse'),
      text: t('Réparation de la anse d’un sac en cuir exotique.'),
      price: t('À partir de 50€'),
      preFilledSteps: {
        selectedCategory: 'accessories',
        selectedAccessory: 'bag',
        selectedFabric: 'leatherAcce',
      },
    }] : [{
      title: t('Réparation griffures'),
      text: t('Réparation de griffures (4) sur l‘ensemble du sac. '),
      price: t('80€'),
      preFilledSteps: {
        selectedCategory: 'accessories',
        selectedAccessory: 'bag',
      },
    }]),
    {
      title: t('Réparation corde'),
      text: t('Réparation de l‘embout tourbillon de la corde beige. '),
      price: t('4€'),
      preFilledSteps: {
        selectedCategory: 'accessories',
        selectedAccessory: 'bag',
      },
    },
    {
      title: t('Nettoyage sac nubuck'),
      text: t(
        'Nettoyage du sac en nubuck orange qui avait perdu de sa vitalité par la saleté.',
      ),
      price: t('70€'),
      preFilledSteps: {
        selectedCategory: 'accessories',
        selectedAccessory: 'bag',
        selectedFabric: 'suede',
      },
    },
    ...(isMobile ? [{
      title: t('Réparation griffures'),
      text: t('Réparation de griffures (4) sur l‘ensemble du sac. '),
      price: t('80€'),
      preFilledSteps: {
        selectedCategory: 'accessories',
        selectedAccessory: 'bag',
      },
    }] : []),
    {
      title: t('Patchwork'),
      text: t(
        'Dessin de patchwork en cuir pour couvrir des tâches sur ce sac à langer. ',
      ),
      price: t('160€'),
      preFilledSteps: {
        selectedCategory: 'accessories',
        selectedAccessory: 'bag',
      },
    },
  ],
  smallLeatherGoods: [
    ...(isMobile ? [{
      title: t('Doublure trousse'),
      text: t('Changement de doublure sur une trousse de toilette. '),
      price: t('45€'),
      preFilledSteps: {
        selectedCategory: 'accessories',
        selectedAccessory: 'wallet',
      },
    }, {
      title: t('Nettoyage & soin'),
      text: t('Nettoyage du cuir et des crochets et cirage du cuir.'),
      price: t('20€'),
      preFilledSteps: {
        selectedCategory: 'accessories',
        selectedAccessory: 'wallet',
      },
    }] : [{
      title: t('Remplacement zip'),
      text: t('Changement d’un zip sur une portefeuille. '),
      price: t('70€'),
      preFilledSteps: {
        selectedCategory: 'accessories',
        selectedAccessory: 'wallet',
      },
    }]),
    {
      title: t('Recoloration 3 bandes'),
      text: t(
        'Nettoyage et recoloration de ce porte monnaie Balenciaga vintage qui avait perdu tout son éclat.',
      ),
      price: t('60€'),
      preFilledSteps: {
        selectedCategory: 'accessories',
        selectedAccessory: 'wallet',
      },
    },
    ...(isMobile ? [{
      title: t('Remplacement zip'),
      text: t('Changement d’un zip sur une portefeuille. '),
      price: t('70€'),
      preFilledSteps: {
        selectedCategory: 'accessories',
        selectedAccessory: 'wallet',
      },
    }] : [{
      title: t('Doublure trousse'),
      text: t('Changement de doublure sur une trousse de toilette. '),
      price: t('45€'),
      preFilledSteps: {
        selectedCategory: 'accessories',
        selectedAccessory: 'wallet',
      },
    }]),
    {
      title: t('Nettoyage & soin'),
      text: t('Nettoyage et cirage de ce porte monnaie pour une seconde vie !'),
      price: t('20€'),
      preFilledSteps: {
        selectedCategory: 'accessories',
        selectedAccessory: 'wallet',
      },
    },
  ],
  dressingEmbroidery: [
    {
      title: t('Collier sur mesure'),
      text: t(
        'Création d’un collier grigri avec de la broderie et des bijoux de vêtements.',
      ),
      price: t('85€'),
      preFilledSteps: {
        selectedCategory: 'clothes',
        selectedCloth: 'haut',
      },
    },
    ...(isMobile ? [{
      title: t('Broderie sur fil tiré'),
      text: t('Astuce broderie pour cacher un petit défaut. '),
      price: t('35€'),
      preFilledSteps: {
        selectedCategory: 'clothes',
        selectedCloth: 'haut',
      },
    },
    {
      title: t('Broderie jeans'),
      text: t('Le détail qui compte. Broderie sur bas de jeans.'),
      price: t('15€'),
      preFilledSteps: {
        selectedCategory: 'clothes',
        selectedCloth: 'jeans',
      },
    }] : [
      {
        title: t('Broderie jeans'),
        text: t('Le détail qui compte. Broderie sur bas de jeans.'),
        price: t('15€'),
        preFilledSteps: {
          selectedCategory: 'clothes',
          selectedCloth: 'jeans',
        },
      },
      {
        title: t('Broderie sur fil tiré'),
        text: t('Astuce broderie pour cacher un petit défaut. '),
        price: t('35€'),
        preFilledSteps: {
          selectedCategory: 'clothes',
          selectedCloth: 'haut',
        },
      },
    ]),
    {
      title: t('Broderies créatives'),
      text: t('Broderie de cils & rythme cardiaque sur coeur. '),
      price: t('15€ / broderie'),
      preFilledSteps: {
        selectedCategory: 'clothes',
        selectedCloth: 'haut',
      },
    },
    ...(isMobile ? [{
      title: t('Petite phrase'),
      text: t('Personnalisez tous vos basics pour vous et vos proches ;)'),
      price: t('30€'),
      preFilledSteps: {
        selectedCategory: 'clothes',
        selectedCloth: 'haut',
      },
    }] : []),
  ],
  interiorEmbroidery: [
    ...(isMobile ? [{
      title: t('Broderie sur serviette'),
      text: t('Personnalisation de serviettes pour toute la famille.'),
      price: t('15€ / prénom'),
      preFilledSteps: {
        selectedCategory: 'deco',
        selectedPiece: 'napkins',
      },
    }] : []),
    {
      title: t('Dessin yeux'),
      text: t('Broderie de petits yeux sur un coussin enfant. '),
      price: t('30€'),
      preFilledSteps: {
        selectedCategory: 'deco',
        selectedPiece: 'cous',
      },
    },
    ...(isMobile ? [{
      title: t('Initiales tradition'),
      text: t('Broderies traditionnelles sur serviettes de table.'),
      price: t('15€ / les initiales'),
      preFilledSteps: {
        selectedCategory: 'deco',
        selectedPiece: 'napkins',
      },
    }] : []),
    {
      title: t('Prénom - name it'),
      text: t('Broderie sur gaz de coton & coton.'),
      price: t('15€ / prénom'),
      preFilledSteps: {
        selectedCategory: 'deco',
        selectedPiece: 'plaid',
      },
    },
    ...(isMobile ? [{
      title: t('Broderie & dessin toast'),
      text: t('Grande broderie sur plaid avec dessin toast'),
      price: t('62€'),
      preFilledSteps: {
        selectedCategory: 'deco',
        selectedPiece: 'plaid',
      },
    }] : [
      {
        title: t('Broderie sur serviette de table'),
        text: t('Personnalisation de serviettes pour toute la famille.'),
        price: t('15€ / prénom'),
        preFilledSteps: {
          selectedCategory: 'deco',
          selectedPiece: 'napkins',
        },
      },
      {
        title: t('Initiales tradition'),
        text: t('Broderies traditionnelles sur serviettes de table.'),
        price: t('15€ / les initiales'),
        preFilledSteps: {
          selectedCategory: 'deco',
          selectedPiece: 'napkins',
        },
      },
    ]),
  ],
  accessoriesEmbroidery: [
    ...(isMobile ? [{
      title: t('Carnet de santé - rose'),
      text: t('Broderie pour personnaliser le carnet de santé de la petite Rose.'),
      price: t('15€'),
      preFilledSteps: {
        selectedCategory: 'accessories',
        selectedAccessory: 'bag',
        selectedFabric: 'textile',
      },
    }] : []),
    {
      title: t('Flamants roses'),
      text: t('Broderie sur espadrilles'),
      price: t('75€'),
      preFilledSteps: {
        selectedCategory: 'accessories',
      },
    },
    ...(isMobile ? [{
      title: t('Broderie porte pinceau'),
      text: t('Personnalisation Léo sur porte pinceau.'),
      price: t('15€'),
      preFilledSteps: {
        selectedCategory: 'accessories',
        selectedAccessory: 'bag',
        selectedFabric: 'textile',
      },
    }] : [{
      title: t('Carnet de santé - rose'),
      text: t('Broderie pour personnaliser le carnet de santé de la petite Rose.'),
      price: t('15€'),
      preFilledSteps: {
        selectedCategory: 'accessories',
        selectedAccessory: 'bag',
        selectedFabric: 'textile',
      },
    }]),
    {
      title: t('Sac personnalisé'),
      text: t('Broderie sur sac de plage en paille. '),
      price: t('40€'),
      preFilledSteps: {
        selectedCategory: 'accessories',
        selectedAccessory: 'bag',
        selectedFabric: 'textile',
      },
    },
    {
      title: t('Bonne nuit'),
      text: t(
        'Personnalisez tous vos accessoires bébé : coussin, tour de lit, doudou, tapis, plaid, etc. ',
      ),
      price: t('30€'),
      preFilledSteps: {
        selectedCategory: 'deco',
        selectedAccessory: 'cous',
      },
    },
  ],
  heels: [
    {
      title: t('Mise en forme'),
      text: t('Mise en forme largeur des mollets pour plus de confort.'),
      price: t('22€'),
      preFilledSteps: {
        selectedCategory: 'accessories',
        selectedAccessory: 'shoes',
        selectedFabric: 'leatherAcce',
      },
    },
    {
      title: t('Changement embout'),
      text: t('Changement de l’embout du talon aiguille.'),
      price: t('8€'),
      preFilledSteps: {
        selectedCategory: 'accessories',
        selectedAccessory: 'shoes',
        selectedFabric: 'leatherAcce',
      },
    },
    {
      title: t('Rénovation complète'),
      text: t(
        'Donnez un nouveau souffle à vos bottes pour qu’elles continuent de vous suivre de longues années.',
      ),
      price: t('65€'),
      preFilledSteps: {
        selectedCategory: 'accessories',
        selectedAccessory: 'shoes',
        selectedFabric: 'leatherAcce',
      },
    },
    {
      title: t('Pose de patins'),
      text: t('Entretien de ces santiags par une pose de nouveaux patins.'),
      price: t('18€'),
      preFilledSteps: {
        selectedCategory: 'accessories',
        selectedAccessory: 'shoes',
        selectedFabric: 'leatherAcce',
      },
    },
  ],
  boots: [
    {
      title: t('Rénovation complète'),
      text: t(
        'Mise en beauté complète pour ces boots : couture d’appoint, semelle, nettoyage cirage etc.',
      ),
      price: t('55€'),
      preFilledSteps: {
        selectedCategory: 'accessories',
        selectedAccessory: 'shoes',
        selectedFabric: 'leatherAcce',
      },
    },
  ],
  sneakers: [
    {
      title: t('Entretien & nettoyage'),
      text: t('Donnez un nouveau souffle à vos baskets avec les artisans TILLI.'),
      price: t('35€'),
      preFilledSteps: {
        selectedCategory: 'accessories',
        selectedAccessory: 'shoes',
        selectedFabric: 'leatherAcce',
      },
    },
    {
      title: t('Nettoyage intégral'),
      text: t(
        'Ne les passez pas à la machine et confiez-les aux artisans cordonniers Tilli. Blanches comme neuves.',
      ),
      price: t('35€'),
      preFilledSteps: {
        selectedCategory: 'accessories',
        selectedAccessory: 'shoes',
        selectedFabric: 'leatherAcce',
      },
    },
    {
      title: t('Ressemelage - sneakers'),
      text: t('Changement des semelles en cuir pour retrouver vos appuis !'),
      price: t('52€'),
      preFilledSteps: {
        selectedCategory: 'accessories',
        selectedAccessory: 'shoes',
        selectedFabric: 'leatherAcce',
      },
    },
    {
      title: t('Rénovation complète'),
      text: t('Faites-les briller ne les laisser pas se ternir ! '),
      price: t('55€'),
      preFilledSteps: {
        selectedCategory: 'accessories',
        selectedAccessory: 'shoes',
        selectedFabric: 'leatherAcce',
      },
    },
  ],
});
